import { render, staticRenderFns } from "./PackageTypeDialog.vue?vue&type=template&id=4a67d3df"
import script from "./PackageTypeDialog.vue?vue&type=script&lang=js"
export * from "./PackageTypeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports